/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toolbar-container[_ngcontent-%COMP%]{display:-webkit-box;display:flex;padding:4px;-webkit-box-pack:justify;justify-content:space-between;border-bottom:1px solid rgba(0,0,0,.12);background:#fafafa}  mat-icon{margin-right:.25em}\n/*# sourceMappingURL=toolbar.component.css.map*/"];
export { styles as styles };
